interface Props {
  loading: boolean;
}

const LoginButton = ({ loading }: Props) => {
  return (
    <button
      type="submit"
      disabled={loading}
      className="w-full py-3 rounded-lg text-white font-medium bg-gradient-to-r from-cyan-600 to-emerald-400"
    >
      {loading ? 'Signing In...' : 'Login'}
    </button>
  );
};

export default LoginButton;
